import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_USER_MUTATION } from '../graphql/mutations'
import { transformToSaveUserArgs } from '../graphql/transformers'
import { UPSERT_USER_DETAILS } from '../redux/action-types'

const useUpdateUserMutation = () => {
  const dispatch = useDispatch()
  const { isLoading, error } = useSelector(store => store.users.user)

  const mutate = useCallback(
    (id, userData) =>
      apolloService.mutate({
        mutation: UPDATE_USER_MUTATION,
        variables: { id, data: transformToSaveUserArgs(userData) },
        dispatch,
        action: UPSERT_USER_DETAILS,
      }),
    [dispatch],
  )

  return [mutate, { isLoading, error }]
}

export default useUpdateUserMutation
